import type { BadgeTone } from '@/components/ui/Badge'
import type { ExecutionStatus, MakeupRequest } from '@/services/productionOrders/executionApi'

export const STATUS_LABEL: Record<ExecutionStatus, string> = {
  PLANNED: 'Chưa bắt đầu',
  READY: 'Sẵn sàng',
  IN_PROGRESS: 'Đang sản xuất',
  COMPLETED: 'Hoàn thành',
  CANCELLED: 'Đã hủy',
}

export const STATUS_TONE: Record<ExecutionStatus, BadgeTone> = {
  PLANNED: 'neutral',
  READY: 'info',
  IN_PROGRESS: 'warning',
  COMPLETED: 'success',
  CANCELLED: 'danger',
}

export const ALLOCATION_LABEL: Record<MakeupRequest['allocation_status'], string> = {
  RESERVED: 'Đã giữ đủ',
  PARTIAL: 'Giữ một phần',
  UNRESERVED: 'Chưa giữ được',
}

export const ALLOCATION_TONE: Record<MakeupRequest['allocation_status'], BadgeTone> = {
  RESERVED: 'success',
  PARTIAL: 'warning',
  UNRESERVED: 'danger',
}

export const MAKEUP_STATUS_LABEL: Record<string, string> = {
  REQUESTED: 'Đã yêu cầu',
  ISSUED: 'Đã xuất đủ',
  CANCELLED: 'Đã hủy',
}

/** Practical Vietnamese for known server error codes; unknown codes fall back to server text. */
const ERROR_VI: Record<string, string> = {
  PLAN_LINE_INACTIVE: 'Lệnh sản xuất đã ngừng hoạt động',
  PRODUCTION_CLOSED: 'Lệnh sản xuất đã đóng, không thể thao tác',
  INVALID_COMPLETION_QTY: 'Số lượng hoàn thành phải lớn hơn 0',
  COMPLETION_EXCEEDS_PLANNED: 'Tổng số lượng hoàn thành vượt số lượng kế hoạch',
  COMPLETION_INCOMPLETE: 'Chưa hoàn thành đủ số lượng kế hoạch nên chưa thể đóng lệnh',
  ACTIVE_MAKEUP_REMAINS: 'Còn yêu cầu bổ sung vật tư chưa xuất, chưa thể đóng lệnh',
  INVALID_MAKEUP_QTY: 'Số lượng bổ sung phải lớn hơn 0',
  MAKEUP_REASON_REQUIRED: 'Cần nhập lý do bổ sung vật tư',
  MAKEUP_REQUEST_NOT_FOUND: 'Không tìm thấy yêu cầu bổ sung vật tư',
  MAKEUP_PLAN_LINE_MISMATCH: 'Yêu cầu bổ sung thuộc lệnh sản xuất khác',
  MAKEUP_NOT_RESERVED: 'Yêu cầu bổ sung chưa được giữ hàng',
  MATERIAL_NOT_FOUND: 'Không tìm thấy vật tư',
  BASE_UOM_MISSING: 'Vật tư chưa có đơn vị đo chuẩn',
  IDEMPOTENCY_KEY_REUSED: 'Thao tác này đã được gửi trước đó với nội dung khác',
  RESERVATION_NOT_ACTIVE: 'Phần giữ hàng không còn hiệu lực',
  NOT_FOUND: 'Không tìm thấy dữ liệu',
}

export function describeError(code: string, serverMessage: string): string {
  return ERROR_VI[code] ?? serverMessage
}

/** Display a NUMERIC string / number: up to 4 decimals, no trailing zeros. */
export function formatQty(value: string | number | null | undefined): string {
  if (value === null || value === undefined || value === '') return '0'
  const n = Number(value)
  if (!Number.isFinite(n)) return String(value)
  return String(Math.round(n * 10000) / 10000)
}

/** Planned minus completed, display only (server validates every action). */
export function remainingQty(planned: number, completed: string | number): number {
  return Math.max(0, Math.round((planned - Number(completed)) * 10000) / 10000)
}
